import { render, staticRenderFns } from "./loading-overlay.vue?vue&type=template&id=67089042&scoped=true"
import script from "./loading-overlay.vue?vue&type=script&lang=js"
export * from "./loading-overlay.vue?vue&type=script&lang=js"
import style0 from "./loading-overlay.vue?vue&type=style&index=0&id=67089042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67089042",
  null
  
)

export default component.exports